<template>
  <div class="event-modal-catalog-navigation">
    <ul
      class="event-modal-catalog-navigation__list"
      v-if="step <= steps.AD_SERVICE"
    >
      <li
        v-for="(item, index) in stepsWithDisabled"
        :key="index"
        class="event-modal-catalog-navigation__list-item"
        :class="[item.classBinding, { show: item.show }]"
      >
        <button
          class="event-modal-catalog-navigation__list-item-action"
          @click="nextStep(steps[item.key])"
          :disabled="item.disabled"
        >
          {{ item.title }}
        </button>
      </li>
    </ul>

    <ul
      class="event-modal-catalog-navigation__list event-modal-catalog-navigation__list_preview"
      v-if="step === steps.PREVIEW"
    >
      <li class="event-modal-catalog-navigation__list-item _active show">
        <button class="event-modal-catalog-navigation__list-item-action">
          {{ this.$t("event.catalog.modal.nav.preview") }}
        </button>
      </li>

      <li class="event-modal-catalog-navigation__list-item show">
        <button
          @click="UPDATE_STEP(steps.AD_SERVICE)"
          class="event-modal-catalog-navigation__list-item-action event-modal-catalog-navigation__list-item-action_back"
        >
          <icon name="back" />

          {{ this.$t("event.catalog.modal.nav.backBtn") }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
  name: "EventModalCatalogNavigation",

  computed: {
    ...mapState("eventCatalog", ["step", "steps", "alphabetList"]),
    ...mapGetters("eventCatalog", [
      "isRubricsStepAllowed",
      "isPackagePlacementStepAllowed"
    ]),

    stepsWithDisabled() {
      let steps = [
        {
          key: "ALPHABET_LIST",
          title: this.$t("event.catalog.modal.nav.alphabetList"),
          disabled: false,
          show: true
        },
        {
          key: "RUBRICS",
          title: this.$t("event.catalog.modal.nav.rubrics"),
          disabled: !this.isRubricsStepAllowed,
          show: true
        },
        {
          key: "RUSSIAN_EXPORTER",
          title: this.$t("event.catalog.modal.nav.russianExporter"),
          disabled:
            !this.isRubricsStepAllowed || !this.isPackagePlacementStepAllowed,
          show: this.alphabetList.companyRussianExporter
        },
        {
          key: "PACKAGE_PLACEMENT",
          title: this.$t("event.catalog.modal.nav.packagePlacement"),
          disabled:
            !this.isRubricsStepAllowed || !this.isPackagePlacementStepAllowed,
          show: true
        },
        {
          key: "AD_SERVICE",
          title: this.$t("event.catalog.modal.nav.adService"),
          disabled:
            !this.isRubricsStepAllowed || !this.isPackagePlacementStepAllowed,
          show: true
        }
      ];

      steps.map(x => {
        x.classBinding = {
          _highlight: this.step >= this.steps[x.key],
          _active: this.step === this.steps[x.key]
        };
      });

      return steps;
    }
  },

  methods: {
    ...mapMutations("eventCatalog", ["UPDATE_STEP"]),

    nextStep(step) {
      this.$emit("nextStep", step);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-modal-catalog-navigation {
  border-bottom: 2px solid #f1f1f1;
  background: #fff;

  &__list {
    display: flex;

    padding: 0;
    margin: 0 0 0 80px;

    list-style: none;

    width: 780px;

    @include respond-down(lg) {
      width: calc(100% - 24 * 2px);
      margin: 0 24px;
      box-sizing: border-box;
    }

    @include respond-down(md) {
      width: calc(100% - 16 * 2px);
      margin: 0 16px;

      flex-wrap: nowrap;
      overflow-x: scroll;

      // to see box-shadow-ish border
      padding-bottom: 3px;
      margin-bottom: -3px;

      -webkit-overflow-scrolling: touch;
      -ms-overflow-style: -ms-autohiding-scrollbar;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    &-item {
      display: none;
      flex-grow: 1;
      text-align: center;

      @include respond-down(md) {
        flex-shrink: 0;
      }

      &.show {
        display: list-item;
      }
      &-action {
        @include button-clean();

        padding: 15px 10px;

        font-size: 13px;
        line-height: 1.54;
        color: #000000;
      }

      &._highlight {
        box-shadow: 0 2px #005197;
      }

      &._active &-action {
        color: #005197;
        font-weight: bold;
      }

      &-action[disabled] {
        color: #cdced0;
        pointer-events: none;
      }
    }

    &_preview {
      box-shadow: 0 2px #005197;
      justify-content: space-between;

      @include respond-down(md) {
        flex-wrap: nowrap;
        overflow-x: initial;
      }
    }

    &_preview &-item {
      flex-grow: 0;

      @include respond-down(md) {
        flex-shrink: 1;
      }

      &-action {
        padding-bottom: 12px;

        @include respond-down(md) {
          padding-left: 0;
          padding-right: 0;
          text-align: left;
        }

        &_back {
          display: flex;
          align-items: center;

          @include respond-down(md) {
            margin-left: 20px;
          }

          color: #009ee3;
          font-weight: 500;

          .svg-icon {
            width: 16px;
            height: 16px;
            margin-right: 10px;
            fill: #009ee3;
          }
        }
      }
    }
  }
}
</style>
